import { render } from "./Recharges.vue?vue&type=template&id=423cfbd8"
import script from "./Recharges.vue?vue&type=script&lang=js"
export * from "./Recharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__